module.exports = __webpack_public_path__ + "img/undefined.9ee839f2.png";